import PropTypes from 'prop-types'
import exact from 'prop-types-exact'

import Block from 'components/lib/content_page/side_bar/block'

const ContentSideBar = ({ page }) => {
  return (
    <>
      {page.sideBarBlocks.map((block, i) => (
        <Block key={i} {...block} />
      ))}
    </>
  )
}

ContentSideBar.propTypes = exact({
  page: PropTypes.object.isRequired
})

export default ContentSideBar
